<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import Datatable from '@/components/Datatable'
import datatableMixin from '@/helpers/mixins/datatableMixin'
 

export default {
    page: {
        title: "Kurulamayanlar Listesi",
    },
    mixins: [ datatableMixin ],
    components: {
        Layout, 
        PageHeader,
        Datatable
    },
    computed: {
       ...mapGetters('authfack',['userdata'])
    },
    data() {
     return {
            title: "KURULAMAYANLAR LİSTESİ",
            items: [
                { text: "ANASAYFA", href: "/" },
                { text: "KURULAMAYANLAR LİSTESİ", active: true }
            ],
            url: "/listeler/kurulamayanlar-listesi",
            buttons:[
                { title:"Geri Al", icon:'bx bx-refresh', func:this.cikart},
            ],  
            columns: [
            { name: '', key: 'action', orderable: false, width:10  },
            { name: '', key: 'cause', className: 'text-end', orderable: false },
            { name: 'İsim Soyisim', key: 'fullname', width: 150 },
            { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', width: 150  },
            { name: 'Telefon', key: 'phonenumber', className: 'text-end', width: 150  },
            { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
            { name: 'İl', key: 'province', className: 'text-end', orderable: true, width: 150  },
            { name: 'Bölge', key: 'township', className: 'text-end', orderable: true, width: 150  },
            { name: 'Adres', key: 'address', className: 'text-end', orderable: true, width: 350  }, 
            ],
            tableData: {
            detail: false,
            excel: true,
            searchable:{
                visible:true,
                placeholder:"İsim Soyisim de Ara"
            }
            },
            endpoint: '/listeler/kurulamayanlar-listesi',
            exportName: 'Kurulamayanlar',
        };
    },
    methods: {

        async loadPage() {
       
            this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
            
            const response = await  this.$http.post(this.endpoint, { params: this.params, sort_column:this.sortColumn, sort_crder:this.sortOrder, search_query: this.searchQuery });
            if (this.params.page === 1) {
                this.tableData.data = response.data.data;
            } else {
                this.tableData.data = [...this.tableData.data, ...response.data.data];
            }
        
            this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
            this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
        },

        expiredate(obj){
            return this.formatDate(obj.expiredate, "DD.MM.YYYY HH:mm")
        },
       
        cikart(props){
            this.$http.post('/listeler/kurulamayanlar/event', { id : props.id })
            .then(() => this.loadItems())
        }
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

    <Datatable 
            :columns="columns" 
            :tableData="tableData" 
            @sort-column="handleSortColumn"
            @search-query="reLoadPage"
            :loading="isLoading"
            :poading="pageLoading"
            @excel-export="excelExport"
            >

            <template #cause="{ row }">
                <span v-b-popover.hover.auto="row.cause" class="badge bg-warning rounded-pill font-size-12" v-if="row.cause"><i class="mdi mdi-alert"></i> Neden</span>
            </template>

            <template #expiredate="{ row }">
                {{  expiredate(row) }}
            </template>
            
            <template #phonenumber="{ row }">
                <a :href="`tel:${row.phonenumber}`">{{ row.phonenumber }}</a>
            </template>

            <template #phonenumber2="{ row }">
                <span v-if="row.phonenumber2">
                    <a :href="`https://wa.me/${row.phonenumber2}`" target="_blank">
                    {{ row.phonenumber2 }}
                    </a>
                </span>
            </template>

            <template #action="{ row }">
                <b-dropdown
                    toggle-class="font-size-16 p-0"
                    toggle-tag="a"
                    variant="white"
                    append-to-body
                    >
                    <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                    </template>
                    <b-dropdown-item v-for="(button,i) in buttons"  :key="i" @click="button.func(row)">{{ button.title }}</b-dropdown-item>
                </b-dropdown>
          </template>

    </Datatable>

    
  </Layout>
</template>